export class IssueReport {
  constructor(public name: string, public value: string) {}
}
